





















































































































































































import Vue from 'vue';
import SideMenu from '@/components/util/SideMenu.vue';
import {
  calcTrialEndDate,
  makeTrialEndDateStr,
  TRIAL_PERIOD_MONTH,
} from '@/class/common/util/trial';

interface IQALink {
  link: string;
  linkCaption: string;
  isHelp: boolean; // ヘルプの別記事へのリンクか
}

interface IQACaptionSet {
  caption: string;
  captionSP: string; // スマホ用
  src: string;
  srcSP: string; // スマホ用
}

interface IQAList {
  captionList: IQACaptionSet[];
}

interface IQATable {
  border: boolean;
  th: string[];
  td: string[][];
}

interface IQAThumnail extends IQACaptionSet {
  heading: string;
  table: IQATable;
  links: IQALink[];
  olCaption: IQAList[]; // 箇条書き:数字
  ulCaption: IQAList[]; // 箇条書き:点
}

interface IQAItem {
  thumbnail: IQAThumnail[];
  subTitle: string;
  url: string;
}

interface IQAData {
  title: string;
  items: IQAItem[];
}

// 無料お試し期間の文字列
const STR_SAMPLE_TRIAL_PERIOD_START = '6/15';
const STR_SAMPLE_TRIAL_PERIOD_END = makeTrialEndDateStr(
  STR_SAMPLE_TRIAL_PERIOD_START,
);

export default Vue.extend({
  name: 'HelpList',
  components: {
    SideMenu,
  },
  data() {
    return {
      qafList: [
        {
          title: '使い方ガイド',
          items: [
            {
              thumbnail: [
                {
                  caption:
                    'インストール方法やユーザー情報の各種紐付けなど、初期設定の詳しい手順を動画でご紹介しております。\n以下のリンクからご覧いただけますので、ぜひご活用ください。',
                  links: [
                    { link: '/service/manual/', linkCaption: 'マニュアル動画' },
                  ],
                },
              ],
              subTitle: 'マニュアル動画',
              url: 'manual',
            },
            {
              thumbnail: [
                {
                  caption: 'トップバーからクライアントツール画面を表示します。',
                  src: '/images/help/01_01.png',
                  srcSP: '/images/help/01_01_sp.png',
                },
                // 画像差し替え必要
                {
                  caption:
                    'Windows版、Mac版またはandroid版のクライアントツールをダウンロードします。',
                  src: '/images/help/01_02.png',
                  srcSP: '/images/help/01_02_sp.png',
                },
                {
                  caption:
                    '対象のデバイスでダウンロードしたファイルを解凍またはインストールします。' +
                    '\n■ Windows版：setup.exeを実行しインストールします。' +
                    '\n\n■ Mac版：RemoLabo.pkgをクリックし、画面に従ってインストールします。' +
                    '\n\n■ Android版：' +
                    '\n　・直接インストールする場合' +
                    '\n　　remolabo-x.x.x-android.apkをタップし、画面に従ってインストールします。',
                },
                {
                  caption:
                    'リモートデスクトップをご利用の場合は、ホスト側のPCにクライアントツールのインストールをお願いいたします。',
                },
                {
                  heading: '問題が発生した場合',
                  caption:
                    'クライアントツール導入時に問題が発生した場合、以下のリンク先をご参照ください。',
                  links: [
                    {
                      link: 'defect',
                      linkCaption:
                        'Q.クライアントツールのトラブルシューティング',
                      isHelp: false,
                    },
                  ],
                },
              ],
              subTitle: '１．クライアントツールのダウンロード・インストール',
              url: 'download',
            },
            {
              thumbnail: [
                {
                  caption:
                    'RemoLabo はコンピュータの利用履歴を記録するため、次回ログイン時にアクセス許可の要求ダイアログが表示されます。\nインストールの完了後、以下の手順でアクセス許可をおこなってください。',
                },
                {
                  heading: '【アクセス許可手順】',
                  olCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'インストーラの案内に従ってコンピュータを再起動します。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'ログイン時に以下の2種類のダイアログが同時に表示されます。',
                        },
                      ],
                    },
                  ],
                },
                {
                  ulCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            '“System Events”に対するアクセス要求 \n下記のダイアログが表示されたら、OKボタンをクリックしてください。\n※同じコンピュータで他のユーザーがログインする際にも表示されます。',
                          src: '/images/help/mac01/1.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'アクセシビリティ機能に対するアクセス要求\n下記のダイアログが表示されたら [”システム環境設定”]を開くをクリックします。\n※管理者権限が必要な操作があります。\n※インストール後の初回ログイン時のみ表示されます。',
                          src: '/images/help/mac01/2.png',
                        },
                        {
                          caption:
                            '左下の鍵のアイコンをクリックし、管理者のユーザー名とパスワードを入力してロックを解除します。',
                          src: '/images/help/mac01/3.png',
                        },
                        {
                          caption:
                            'リストに表示されている“RemoLaboAgent”にチェックを入れてください。',
                          src: '/images/help/mac01/4.png',
                        },
                      ],
                    },
                  ],
                },
                {
                  caption: 'インストール後の設定手順については以上になります。',
                },
              ],
              subTitle: ' ※インストール後の設定（Mac版）',
              url: 'settings_after_install_mac',
            },
            {
              thumbnail: [
                {
                  caption:
                    'RemoLabo はスマートフォンの利用履歴を記録するため、初期設定の操作を行う必要があります。' +
                    '\nアプリインストールの完了後、アプリを起動し、以下の手順で初期設定を行ってください。',
                },
                {
                  heading: '【初期設定手順】\n',
                  olCaption: [
                    {
                      captionList: [
                        { caption: '「初回セットアップを開始する」をタップ' },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'データ収集等に関する文章を読み、同意する場合はチェックボタンを押し、次へボタンを押してください。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '「権限の確認」以下に表示されている×マークとなっている項目をタップし、各種設定画面へ飛びます。\n',
                        },
                        { caption: '\n・アクセシビリティサービス' },
                        {
                          caption:
                            '　ユーザー補助画面に遷移した後、「インストール済みアプリ」をタップ ',
                          src: '/images/help/android/02.png',
                        },
                        {
                          caption: '　「remolabo_client」をタップ',
                          src: '/images/help/android/03.png',
                        },
                        {
                          caption: '　トグルボタンを「ON」に変更',
                          src: '/images/help/android/04.png',
                        },
                        {
                          caption:
                            '　※「セキュリティ上の理由により、この設定は利用できません」と表示される場合',
                        },
                        {
                          caption:
                            '　　設定アプリ → アプリ remolabo_client → 右上の3点のアイコンをタップ → 制限付き設定を許可',
                        },
                        { caption: '　　を行うと許可が行えるようになります。' },
                        { caption: '\n・通知取得権限' },
                        {
                          caption:
                            '　「通知アクセス」に遷移し、remolabo_clientのトグルボタンをオンにします。',
                          src: ' /images/help/android/05.png ',
                        },
                        { caption: '\n・通話履歴の取得権限\n' },
                        {
                          caption:
                            '　アクセス許可のポップアップが出現するので許可をタップ',
                          src: '/images/help/android/06.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        { caption: 'デバイスとアカウント間の紐づけを行うため' },
                        {
                          caption:
                            'メールアドレスとスマホキーを入力し、「入力完了」を押下します。',
                        },
                        { caption: '\n※スマホキーの確認方法については、' },
                        {
                          caption:
                            '　クライアントツール画面から「スマホキーを表示」ボタンの押下で確認できます。',
                          src: '/images/help/android/07.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '中央にコピーライトが表示される画面で初期設定が完了となります。',
                        },
                      ],
                    },
                  ],
                },
              ],
              subTitle: ' ※インストール後の設定（Android版）',
              url: 'settings_after_install_android',
            },
            {
              thumbnail: [
                {
                  caption: 'トップバーから、ユーザー管理画面を表示します。',
                  src: '/images/help/02_01.png',
                  srcSP: '/images/help/02_01_sp.png',
                },
                {
                  caption:
                    ' [新規追加] ボタンの次に [ユーザーを追加] ボタンを押して、管理したいユーザーの情報を入力し、右上の [次へ] ボタンを押します。',
                  captionSP:
                    '右上の [追加] ボタン ＞  [ユーザーを追加] ボタンを押して、管理したいユーザーの情報を入力し、 [次へ] ボタンを押します。',
                  src: '/images/help/02_02.png',
                  srcSP: '/images/help/02_02_sp.png',
                },
                {
                  caption:
                    'ユーザーの基本情報を入力し、 [決定] ボタンを押すとユーザーが作成されます。\n各入力項目の詳細については、下記「■基本情報の設定項目」をご参照ください。',
                  src: '/images/help/02_03.png',
                  srcSP: '/images/help/02_03_sp.png',
                },
                {
                  heading: '■基本情報の設定項目',
                  caption:
                    '\n【部署】\n所属対象の部署を選択します。\n部署の概要や作成方法については、以下のリンクをご参照ください。',
                  links: [
                    {
                      link: 'department',
                      linkCaption: 'Q.部署機能について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '【職種】\nユーザーの職種を選択します。\n職種によって実労働時間などのグラフに表示される時間のカウント基準が異なりますので、以下のリンクをあわせてご参照ください。',
                  links: [
                    {
                      link: 'calculation',
                      linkCaption: 'Q.実労働時間の算出方法',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '【グループ】\n所属対象のグループを選択します。\nユーザー管理画面ではアカウント管理者が作成したグループのみ紐づけ可能です。\n労務管理者がユーザーとグループの紐づけを行う場合、以下のリンク先の手順に沿ってグループ管理画面から設定を行ってください。',
                  links: [
                    {
                      link: 'group_function',
                      linkCaption: 'Q.グループ機能について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '【就業形態】\nユーザーの就業形態を選択します。\n就業形態の概要や作成方法については、以下のリンクをご参照ください。',
                  links: [
                    {
                      link: 'work_settings',
                      linkCaption: 'Q.就業形態について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '【フレックスタイム】\nフレックスタイム制の場合、チェックONにします。\nまた、チェックONにすると、アラート通知機能の36協定通知の時間外労働がフレックスタイムで計算されます。',
                  links: [
                    {
                      link: 'notification',
                      linkCaption: 'Q.アラート通知機能について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '【権限】\nユーザーの権限を [一般] と [労務管理者] のいずれかに設定します。\n[労務管理者] を選択すると [招待メール宛先] の入力欄が表示されますので、RemoLaboへのログインに使用するメールアドレスを入力します。[決定]ボタン押下後、入力したメールアドレス宛に招待メールが届きますので、メールの案内に従ってパスワード設定をおこなってください。',
                },
                {
                  caption: '権限ごとに表示できる画面は以下の通りです。\n',
                  // 'また、権限ごとに行える操作は以下の通りです。\n\n・一般\n　RemoLaboにログイン不可\n\n・労務管理者\n　RemoLaboにログイン可能、次の画面を閲覧・操作可能：\n　ダッシュボード、グループ管理、アラート通知、お知らせ、ガイド・よくある質問、お問い合わせ\n\n・アカウント管理者\n　RemoLaboにログイン可能、全ての画面を操作可能\n　※最初にアカウント登録したユーザーのみがアカウント管理者権限を使用可能',
                  table: {
                    border: true,
                    th: [
                      '画面 / 権限',
                      'アカウント\n管理者',
                      '労務管理者',
                      '一般',
                    ],
                    td: [
                      ['ダッシュボード', '○', '○', '‐'],
                      ['ユーザー管理', '○', '‐', '‐'],
                      ['グループ管理', '○', '○', '‐'],
                      ['就業形態管理', '○', '‐', '‐'],
                      ['業務管理', '○', '‐', '‐'],
                      ['アラート通知', '○', '○', '‐'],
                      ['ご契約者情報', '○', '‐', '‐'],
                      ['ライセンス・お支払い情報', '○', '‐', '‐'],
                      ['クライアントツール', '○', '‐', '‐'],
                      ['お知らせ', '○', '○', '‐'],
                      ['ガイド・よくある質問', '○', '○', '‐'],
                      ['お問い合わせ', '○', '○', '‐'],
                    ],
                  },
                },
                {
                  caption:
                    '※一般権限はログイン不可\n※最初にアカウント登録したユーザーのみがアカウント管理者権限を使用可能',
                },
                {
                  caption:
                    '【デバイス】\nユーザーのデバイス（コンピュータ＆PCアカウント）を選択します。\n同一コンピュータで複数のPCアカウントを使用している場合、任意のPCアカウントだけを紐づけることも可能です。\nクライアントツールのインストールが完了してもデバイスの選択肢に表示されない場合、ネットワーク環境により反映までに数時間かかることがございますので何卒ご了承ください。',
                },
                {
                  caption:
                    '【労務管理者】\nユーザーのログを閲覧する管理者を選択します。\n労務管理者が自分自身のログを見られるようにするには、当該ユーザーの [労務管理者] にそのユーザー自身を設定します。',
                },
                {
                  caption:
                    '【業務】\nユーザーの業務を選択します。\n業務の概要や作成方法については、以下のリンクをご参照ください。',
                  links: [
                    {
                      link: 'workmanage',
                      linkCaption: 'Q.業務管理について',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: '２．ユーザーとデバイス等の関連付け',
              url: 'user_associate',
            },
            {
              thumbnail: [
                {
                  caption:
                    'ユーザーの関連付けが完了すると、ダッシュボードのグラフが実際の操作ログに基づいた情報を表示するようになります。\n※該当ユーザーの労務管理者のみ閲覧・管理が可能\n' +
                    '\nまた、グラフの左上にあるプルダウンで、任意の日付やメンバー（または部署、グループ）を選択すると、実労働時間や残業時間などの情報をご確認いただけます。\nアカウント管理者や労務管理者の間で、ダッシュボードに追加したグラフやタブ、また新規作成したグラフは共有できませんのでご注意ください。',
                  src: '/images/help/03_02.png',
                },
                {
                  caption:
                    'グラフはダッシュボードの [グラフを追加] ＞ [新規作成] で開いたグラフ作成画面にて、お好みの表示項目・グラフ種類を選択して新たに作成することができます。\n作成したグラフをダッシュボードに追加した後は、大きさ等を自由に変えることができます。',
                  captionSP:
                    'グラフはダッシュボード右下の ＋（プラスボタン）＞ [グラフを新規作成] で開いたグラフ作成画面にて、お好みの表示項目・グラフ種類を選択して新たに作成することができます。',
                  src: '/images/help/03_03.png',
                  srcSP: '/images/help/03_03_sp.png',
                },
              ],
              subTitle: '３．グラフでの確認',
              url: 'check_graph',
            },
          ],
        },
      ] as IQAData[],
      qafList2: [
        {
          title: 'よくある質問',
          items: [
            {
              thumbnail: [
                {
                  heading: '・初期費用',
                  caption:
                    '初期費用は0円です。月々の利用料金は110円(税込)/パソコン1台となっており、オプション等の追加料金なしで全ての機能をご利用いただけます。\n1台のパソコンを2つ以上のPCユーザーで切り替えて使用する場合、ユーザー管理画面の[デバイス]に同一PCが複数表示されますが、料金は1台分となります。',
                },
                {
                  heading: '・最小契約数',
                  caption: '1台からのご契約が可能です。',
                },
                {
                  heading: '・最小契約期間',
                  caption: '契約期間の制約はございません。',
                },
                {
                  heading: '・システム条件',
                  caption:
                    'Windows 8/10/11(64bitOSのみ)\nMacOS 10.14以降\nAndroid 12以降',
                },
                {
                  heading: '・動作環境',
                  caption:
                    'ブラウザは「Google Chrome」または「Safari」のご利用をお願いいたします。',
                },
                {
                  heading: '・ネットワーク条件',
                  caption:
                    '現時点でVPNは不可となっており、通常のインターネット回線が必要となっております。',
                },
              ],
              subTitle: 'Q.RemoLaboの導入条件について',
              url: 'conditions',
            },
            {
              thumbnail: [
                {
                  heading:
                    '■クライアントツールのダウンロード時、不正のファイルとなる場合',
                  caption: 'ブラウザ下の継続を押しダウンロードしてください。',
                },
                {
                  heading: '■インストール時にエラーが発生する場合',
                  caption:
                    '「Error 1001 インストールする資格がありません」などのエラーが表示される場合、以下の手順でインストールをお願いいたします。\n\n',
                  olCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'zipファイルを右クリックして、[すべて展開] を選択します。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '解凍が完了するとフォルダが作成されますので、そのフォルダ内に含まれる setup.exe をWindowsの管理者権限で実行します。',
                        },
                      ],
                    },
                  ],
                },
                {
                  heading:
                    '■Android版クライアントツールのインストール時に「不明なアプリのインストール」と表示される場合',
                  caption:
                    '「不明なアプリのインストール」のメッセージで拒否される場合は、以下の手順でインストールをお願いいたします。\n※使用している端末によって操作が異なる場合があります。\n\n',
                  olCaption: [
                    {
                      captionList: [
                        { caption: '「設定」のアプリをタップします。' },
                      ],
                    },
                    {
                      captionList: [{ caption: '「アプリ」をタップします。' }],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'ブラウザやファイル管理などのインストールに用いるアプリを選択します。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '「不明なアプリをインストール」をタップします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '「この提供元を許可」のトグルボタンをオンにします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        { caption: '再度apkのインストールを試みます。' },
                      ],
                    },
                  ],
                },
                {
                  heading:
                    '■クライアントツール導入時、ノートンのチェックが入り「Setup.exe」が削除された場合',
                  caption:
                    '下記手順をご参照いただき、ファイルの除外をお願いいたします。\n\n',
                  olCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'ノートンを起動し、［マイノートン］ウィンドウが開いたら［デバイスセキュリティ］の横にある［開く］をクリックします。',
                        },
                      ],
                    },
                    {
                      captionList: [{ caption: '［設定］をクリックします。' }],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '［設定］ウィンドウで、［ウイルス対策］をクリックします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '［スキャンとリスク］タブで、［自動保護、SONAR、ダウンロードインテリジェンスの検出から除外する項目］の横の［設定］をクリックします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '［リアルタイム除外］ウィンドウで、［ファイルの追加］または［フォルダの追加］をクリックします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '［項目の追加］ウィンドウで、ファイルまたはフォルダを参照して選択し、［OK］ボタンをクリックします。',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '［適用］ボタン、［OK］ボタンの順にクリックします。',
                        },
                      ],
                    },
                  ],
                },
                {
                  heading:
                    '■クライアントツールからのログが送信されなくなった場合',
                  caption:
                    '・Windowsの場合\nクライアントツール画面の [アップデート] にあるボタンを押してアップデート用ファイルをダウンロードします。\nダウンロードしたzipファイルを解凍し、解凍後のフォルダに含まれる remolaboUpdate.exe を実行してアップデートを行ってください。\n\n' +
                    '・Androidの場合\nアップデートの確認と権限の確認を行ってください。\n権限の確認はアプリを開いていただき、権限が剥奪されていた場合画面が表示されますので、再度認証を行ってください。\n\n' +
                    'アップデートを行っても改善しない、またはMacをご利用の場合、大変お手数ではございますが、お問い合わせいただけますようお願いいたします。',
                  captionSP:
                    '・Windowsの場合\nクライアントツール画面の [既にインストール済みの方はこちら] にあるボタンを押してアップデート用ファイルをダウンロードします。\nダウンロードしたzipファイルを解凍し、解凍後のフォルダに含まれる remolaboUpdate.exe を実行してアップデートを行ってください。\n\n' +
                    '・Androidの場合\nアップデートの確認と権限の確認を行ってください。\n権限の確認はアプリを開いていただき、権限が剥奪されていた場合画面が表示されますので、再度認証を行ってください。\n\n' +
                    'アップデートを行っても改善しない、またはMacをご利用の場合、大変お手数ではございますが、お問い合わせいただけますようお願いいたします。',
                  links: [
                    { link: '/contact', linkCaption: 'お問い合わせはこちら' },
                  ],
                },
              ],
              subTitle: 'Q.クライアントツールのトラブルシューティング',
              url: 'defect',
            },
            {
              thumbnail: [
                {
                  heading: '・就業時間の登録方法',
                  caption:
                    '就業形態管理 画面左上の [就業形態を追加] をクリックします。全ての必須項目を入力し、 [登録] をクリックすると就業時間の登録が完了します。',
                  captionSP:
                    '就業形態管理 画面右上の [追加] ボタンを押します。全ての必須項目を入力し、 [登録] ボタンを押すと就業時間の登録が完了します。',
                },
                {
                  heading: '・就業形態とユーザーの連携方法',
                  caption:
                    '就業形態管理画面の [対象ユーザー] の [編集] ボタンを押し、対象のユーザーを選択後 [更新] ボタンを押すと、就業形態を適用するユーザーを設定できます。',
                },
                {
                  heading: '・締め日の設定',
                  caption:
                    '締め日を調整することにより、月毎のグラフで表示される期間を変更することができます。\n設定の際は就業形態管理画面の [勤怠締め日] をご確認ください。\n例)25日に設定すると26日から次月の判定となります。',
                },
              ],
              subTitle: 'Q.就業形態について',
              url: 'work_settings',
            },
            {
              thumbnail: [
                {
                  heading: '・出勤の打刻方法',
                  caption:
                    'RemoLaboでは操作開始時刻を自動的に記録し、マウス操作やキーボードの打鍵記録を基に勤務時間を自動で集計いたします。したがって、手動で打刻をしていただく必要はございません。',
                },
                {
                  heading: '・実労働時間の算出方法',
                  caption:
                    '15分間でユーザーの操作回数(キー入力数＋マウス操作回数)が、職種ごとに設定された基準操作回数以上を達成すると「15分間勤務した」とされます。基準操作回数は「生産性管理」で設定できます。',
                },
                {
                  heading: '・職種の設定方法',
                  caption:
                    'ユーザー管理画面の [基本情報] にある編集ボタンを押下し、編集画面で職種を設定します。',
                  src: '/images/help/q06_01.png',
                  srcSP: '/images/help/q06_01_sp.png',
                },
              ],
              subTitle: 'Q.実労働時間の算出方法',
              url: 'calculation',
            },
            {
              thumbnail: [
                {
                  caption:
                    '標準で2年間のログデータを保管しており、無料体験中と有料プラン利用中はいつでも閲覧可能です。',
                },
                {
                  caption:
                    'さらに、データ保管期間延長オプションに加入いただくことでログの閲覧可能な期間を1年単位で延長することができます。\nオプションの月額料金は対象のパソコン台数×延長年数×110円（税込）となります。',
                },
                {
                  caption:
                    'また、ライセンスの解約を行った場合でも、再度有料プランにお申し込みいただくことで過去に取得したログデータを閲覧することが可能です。',
                },
                {
                  caption:
                    '※オプションの解約、延長年数や台数を小さい数に変更した場合、実際に適応されるのは翌月以降となります。',
                },
                {
                  caption: '■関連記事',
                  links: [
                    {
                      link: 'license',
                      linkCaption: 'Q.ライセンス・料金について',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: 'Q.ログの保管期間について',
              url: 'storage_period',
            },
            {
              thumbnail: [
                {
                  caption:
                    'グループ機能は、グラフやログ内容をグループごとに確認できる機能です。\nアカウント管理者、労務管理者のどちらの権限でも設定することができます。\n※設定されたグループは他の管理者の画面で見ることはできません。\n\n【グループ例】\nA社担当グループ、B社担当グループ、C製品開発グループ、…等',
                },
                {
                  caption:
                    '【設定方法】\nトップバー [グループ管理] ＞ [グループを追加] をクリックしてグループ名を設定してください。',
                  captionSP:
                    '【設定方法】\nトップバーから [グループ管理] を選び、右上の [追加] を押してグループ名を設定してください。',
                  src: '/images/help/q08_01.png',
                  srcSP: '/images/help/q08_01_sp.png',
                },
                {
                  caption:
                    'グループのユーザーを選択し、決定ボタンを押すと、グループが作成されます。',
                  src: '/images/help/q08_04.png',
                  srcSP: '/images/help/q08_04_sp.png',
                },
                {
                  caption:
                    'ダッシュボードの [グラフを追加] ＞ [新規作成] で開いたグラフ作成画面にて [グループ] を選択すると、グループごとの勤怠をご確認いただけます。',
                  captionSP:
                    'ダッシュボード右下の ＋（プラスボタン）＞ [グラフを新規作成] で開いたグラフ作成画面にて [グループ] を選択すると、グループごとの勤怠をご確認いただけます。',
                  src: '/images/help/q08_02.png',
                  srcSP: '/images/help/q08_02_sp.png',
                },
                {
                  caption:
                    '作成したグラフをダッシュボードに追加すると、以下のようにグループごとに管理することができます。',
                  src: '/images/help/q08_03.png',
                  srcSP: '/images/help/q08_03.png',
                },
                {
                  caption: '【関連記事】',
                  links: [
                    {
                      link: 'department',
                      linkCaption: 'Q.部署機能について',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: 'Q.グループ機能について',
              url: 'group_function',
            },
            {
              thumbnail: [
                {
                  caption:
                    '部署機能は、ユーザーを部署単位で管理するための機能で、中規模以上の組織管理に適しています。\n本機能の使用により、以下のことができるようになります。\n\n' +
                    '＜部署内のユーザーをまとめて管理する＞\n部署に労務管理者を設定すると、部署内のユーザーはその労務管理者の管理対象になります。\n\n' +
                    '＜階層型の組織を管理する＞\n部署は2階層まで作成可能で、親部署の労務管理者は配下の部署すべてを管理することができます。\n\n' +
                    '＜ダッシュボードやグラフを部署ごとに見る＞\nダッシュボードを部署ごとに管理したり、グラフやリストを部署ごとに見ることができます。',
                },
                {
                  caption:
                    '■設定方法\n ユーザー管理画面の [新規追加] ＞ [部署を追加] で、下記項目を設定してください。\n※作成した部署については、その部署に設定した労務管理者ユーザーから参照できますが、部署の編集やメンバーの変更はできません。\n\n【設定項目】\n' +
                    '・部署名：部署の名称を入力します。\n・親部署：既にある部署の下に作成する場合、上の階層の部署を選択します。\n・労務管理者：部署の管理者を選択します。\n・業務：部署のメイン業務を選択します。業務については以下のリンク先で詳しく説明しています。',
                  captionSP:
                    '■設定方法\n ユーザー管理画面の右上の [追加] ＞ [部署を追加] で、下記項目を設定してください。\n作成した部署については、その部署に設定した労務管理者ユーザーからも参照のみ可能です。\n※編集やメンバーの変更はできません。\n\n【設定項目】\n' +
                    '・部署名：部署の名称を入力します。\n・親部署：既にある部署の下に作成する場合、上の階層の部署を選択します。\n・労務管理者：部署の管理者を選択します。\n・業務：部署ユーザーのメイン業務を選択します。業務については以下のリンク先で詳しく説明しています。',
                  src: '/images/help/q11_01.png',
                  srcSP: '/images/help/q11_01_sp.png',
                  links: [
                    {
                      link: 'workmanage',
                      linkCaption: 'Q.業務管理について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '全て設定できたら [次へ] ボタンを押します。部署のユーザーを選択し、決定ボタンを押すと部署の作成が完了します。',
                  src: '/images/help/q11_02.png',
                  srcSP: '/images/help/q11_02_sp.png',
                },
                {
                  caption:
                    'ダッシュボードの一覧で部署を選択すると、部署ごとのダッシュボードが表示されます。\nデフォルトで表示されているグラフ以外にも部署用のグラフをご用意していますので、 [グラフを追加] ボタンからご利用ください。',
                  captionSP:
                    'ダッシュボードの一覧で部署を選択すると、部署ごとのダッシュボードが表示されます。\nデフォルトで表示されているグラフ以外にも部署用のグラフをご用意していますので、右下の ＋（プラスボタン）＞ [グラフを追加] ボタンからご利用ください。',
                  src: '/images/help/q11_03.png',
                  srcSP: '/images/help/q11_03_sp.png',
                },
                {
                  caption: '■関連記事',
                  links: [
                    {
                      link: 'group_function',
                      linkCaption: 'Q.グループ機能について',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: 'Q.部署機能について',
              url: 'department',
            },
            {
              thumbnail: [
                {
                  caption:
                    'RemoLaboでは、CSVを使ってユーザー、部署、データ関連付けを一括登録できます。\nCSVとは、登録したいデータをカンマ区切りで表現したフォーマットです(例：データA,データB,データC)。',
                  captionSP:
                    'RemoLaboでは、CSVを使ってユーザー、部署、データ関連付けを一括登録できます。※本機能はPCからご利用いただけます\nCSVとは、登録したいデータをカンマ区切りで表現したフォーマットです(例：データA,データB,データC)。',
                },
                {
                  heading: '・CSVテンプレートのダウンロード',
                  caption:
                    'トップバー [ユーザー管理] ＞ [新規追加] ＞ [CSVで追加] の順にボタンを押すと下の画面が開きます。\nCSVテンプレートの各ボタンから、CSVテンプレートファイルがダウンロードできます。',
                  src: '/images/help/q10_01.png',
                },
                {
                  caption:
                    'CSVテンプレートファイルを開くと、1行目にファイル種別、2行目にデータヘッダー、3行目以降に参考情報が記載されています。\n参考情報の内容を見ながらカンマ区切りでヘッダー順に情報を記述することで、CSVデータを作成できます。\n※参考情報はインポート前に削除してください。',
                },
                {
                  heading: '・インポート方法',
                  caption:
                    '点線のエリアにCSVファイルを配置するとファイル名が表示されます。\nその後インポートボタンを押すとデータが読み込まれます。',
                  src: '/images/help/q10_02.png',
                },
                {
                  caption:
                    'インポート内容に問題がなければ [この内容でインポート] ボタンを押下します。\nエラーが表示された場合は、指示に従って修正して下さい。',
                  src: '/images/help/q10_03.png',
                },
              ],
              subTitle: 'Q.CSVインポートについて',
              url: 'import',
            },
            {
              thumbnail: [
                {
                  caption:
                    '業務管理機能は、操作数が少ない場合でも特定の条件を満たすことで実労働時間に含めることができるようにする機能です。\n実労働時間の算出方法については以下のリンク先に記載しています。',
                  links: [
                    {
                      link: 'calculation',
                      linkCaption: 'Q.実労働時間の算出方法',
                      isHelp: true,
                    },
                  ],
                },
                {
                  caption:
                    '例えばミーティング中にマウス・キーボード操作がなかった場合、通常その時間は実労働時間グラフで0分と表示されます。\nそこで「特定のアプリやウィンドウを開いたときは必ず勤務したこととする」という設定を行うことで、ミーティングを行っていた時間も実労働時間に含めることができるようになります。',
                },
                {
                  heading: '■設定方法',
                  caption: 'トップバーから 業務管理画面を開きます。',
                  src: '/images/help/q13_01.png',
                  srcSP: '/images/help/q13_01_sp.png',
                },
                {
                  caption:
                    '左上の [業務管理を追加] ボタンを押して以下を入力し、 [次へ] ボタンを押します。',
                  captionSP:
                    '右上の [追加] ボタンを押して以下を入力し、 [次へ] ボタンを押します。',
                },
                {
                  caption: '【業務管理名】',
                  ulCaption: [
                    {
                      captionList: [
                        { caption: '業務管理の名称を入力します。' },
                      ],
                    },
                  ],
                },
                {
                  caption: '【業務扱い設定】',
                  ulCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'アプリ名\n操作があったら必ず勤務したことにするアプリケーション名やウィンドウタイトルを入力します。\n※大文字・小文字区別なし\n\n',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '種別\n作業ログデータのアプリケーション名・ウィンドウタイトルと [アプリ名] の一致条件を選択します。',
                        },
                      ],
                    },
                  ],
                  table: {
                    border: true,
                    th: ['種別', '説明'],
                    td: [
                      [
                        'アプリ・ウィンドウ',
                        'アプリケーション名またはウィンドウタイトルのどちらか一方でも一致',
                      ],
                      ['アプリ', 'アプリケーション名と一致'],
                      ['ウィンドウ', 'ウィンドウタイトルと一致'],
                    ],
                  },
                  src: '/images/help/q13_02.png',
                  srcSP: '/images/help/q13_02_sp.png',
                },
                {
                  caption:
                    '業務を適用するユーザーを選択し、決定ボタンを押すと業務管理が追加されます。',
                  src: '/images/help/q13_03.png',
                  srcSP: '/images/help/q13_03_sp.png',
                },
                {
                  caption:
                    'これで業務管理の設定は完了です。\n作成した業務管理は、次に示す例のようにグラフに適用されます。',
                },
                {
                  heading: '■グラフ例',
                  caption:
                    '以下の作業ログデータのように、 [アプリケーション名] や [ウィンドウタイトル] に業務管理画面の [業務扱い設定]＞[アプリ名] で設定した名称が含まれていて、[キー操作数] と [マウス操作数] が少ないデータをグラフで表示すると、下のグラフ画像のようになります。',
                  src: '/images/help/q13_04.png',
                },
                {
                  caption:
                    '5月1日の11時と13時の作業が、実労働時間として表示されることが確認できます。',
                  src: '/images/help/q13_05.png',
                },
                {
                  heading: '■注意点',
                  caption:
                    '作業ログデータに表示されるのはアクティブウィンドウ（操作中のウィンドウ）のみであるため、業務扱いとして設定したアプリがアクティブウィンドウの裏側に表示されていたり、ブラウザの別タブとして表示されている場合は、業務管理の設定が適用されませんのでご注意ください。',
                },
              ],
              subTitle: 'Q.業務管理について',
              url: 'workmanage',
            },
            {
              thumbnail: [
                {
                  caption:
                    'アラート通知機能は、事前に設定した残業時間を超過したり、特定のサイトを閲覧したユーザーが通知される機能です。\n設定値に達したアラートは、操作の翌日午前6:00にニュース／アラート画面表示およびメールで通知されます。',
                },
                {
                  heading: '■36協定通知',
                  caption:
                    '1日／1箇月／1年の時間外労働が設定値を超えると通知されます。\nアラートは職種ごとに設定でき、該当職種の設定されたユーザーのみがアラート対象となります。\n' +
                    'また、一般条項を超える値を特別条項に設定することにより、2段階でのアラートが可能になります。\n時間外労働は種類ごとに以下の時間となります。\n\n',
                  ulCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            '所定労働時間外\n所定労働時間(※1)を超えた労働時間、休日の労働時間\n（フレックスタイム(※2)の場合、1ヶ月の労働時間合計から1ヶ月の所定労働時間合計を引いた時間）\n\n',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '法定労働時間外\n1日8時間を超えた労働時間、週40時間を超えた労働時間、法定休日の労働時間\n（フレックスタイム(※2)の場合、1ヶ月の労働時間合計から法定労働時間の総枠(※3)を引いた時間）\n\n',
                        },
                      ],
                    },
                  ],
                  table: {
                    border: false,
                    td: [
                      [
                        '※1',
                        '所定労働時間：始業から終業までの時間から休憩を引いた時間を指します',
                      ],
                      [
                        '※2',
                        'ユーザー管理画面でフレックスタイムが「あり」に設定されたユーザーが対象となります。\nまたフレックスタイムのユーザーは1箇月・1年のアラートのみが有効となりますので、1日のアラートを設定した場合、当該アラート通知は行われません。',
                      ],
                      [
                        '※3',
                        '法定労働時間の総枠：月の日数により以下となります\n・31日：177.1時間\n・30日：171.4時間\n・29日：165.7時間\n・28日：160.0時間\n',
                      ],
                    ],
                  },
                },
                {
                  heading: '■勤務間インターバル通知',
                  caption:
                    '一定時間の間隔を開けずに勤務を開始すると通知されます。',
                },
                {
                  heading: '■禁止アプリの使用通知',
                  caption:
                    '設定したアプリ、ウィンドウを開くと通知されます。設定項目は以下の通りです。\n\n',
                  ulCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'アプリ名\n操作を禁止するアプリケーション名やウィンドウタイトルを入力します。※大文字・小文字区別なし\n\n',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '種別\n作業ログデータのアプリケーション名・ウィンドウタイトルと [アプリ名] の一致条件を選択します。\n\n',
                        },
                      ],
                    },
                  ],
                  table: {
                    border: true,
                    th: ['種別', '説明'],
                    td: [
                      [
                        'アプリ・ウィンドウ',
                        'アプリケーション名またはウィンドウタイトルのどちらか一方でも一致',
                      ],
                      ['アプリ', 'アプリケーション名と一致'],
                      ['ウィンドウ', 'ウィンドウタイトルと一致'],
                    ],
                  },
                },
                {
                  heading: '■月間レポート',
                  caption:
                    '先月以前の36協定違反、勤務間インターバル違反、禁止アプリ使用の各状況についてサマリを確認できます。',
                },
                {
                  heading: '【アラート通知設定方法】',
                  caption:
                    'トップバーの [アラート通知] ＞ サイドバー [通知設定] からアラート通知設定ができます。',
                  captionSP:
                    'トップバーから [アラート通知] を選択後、 [設定] からアラート通知設定ができます。',
                  src: '/images/help/q09_01.png',
                  srcSP: '/images/help/q09_01_sp.png',
                },
                {
                  caption:
                    'アラート通知の一覧は、トップバーの [アラート通知] からご確認いただけます。',
                  captionSP:
                    'アラート通知の一覧は、 [アラート通知] からご確認いただけます。',
                  src: '/images/help/q09_02.png',
                  srcSP: '/images/help/q09_02_sp.png',
                },
              ],
              subTitle: 'Q.アラート通知機能について',
              url: 'notification',
            },
            {
              thumbnail: [
                {
                  heading: '・操作ログの抽出方法',
                  caption:
                    'ダッシュボード画面左上にある [グラフを追加] ボタンをクリックし、[CSVダウンロード] ガジェットをダッシュボードに追加します。その後、対象のユーザーと日付を選択していただくとログの詳細表示やダウンロードができます。',
                },
                {
                  heading:
                    '・CSVダウンロードでExcel変換する際に文字化けしてしまった場合',
                  caption:
                    '文字化けはExcelの表示仕様の問題となっており、文字コードを変えて読み込む等の対処をすることで正常に表示されるようになります。下記の手順をお試しください。\n\n',
                  olCaption: [
                    {
                      captionList: [
                        {
                          caption: 'メモ帳でCSVファイルを開きます。',
                          src: '/images/help/q04_01.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'メモ帳で文字化けせずに表示されていたら、ファイル→上書き保存をします。',
                          src: '/images/help/q04_02.png',
                        },
                        {
                          caption:
                            'ファイルの種類：すべてのファイル 文字コード(E) ：ANSI',
                          src: '/images/help/q04_03.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '保存したデータをExcelのデータ→[テキストまたはCSVから]を選択し、先ほど保存したファイルをExcelで開きます。',
                          src: '/images/help/q04_04.png',
                        },
                        {
                          caption:
                            '開いたデータが文字化けせずきちんと表示されていたら、データの変換ボタンをクリックします。',
                          src: '/images/help/q04_05.png',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '閉じて読み込むを選択し、文字化けせずに表示されていることが確認できれば完了です。',
                        },
                      ],
                    },
                  ],
                },
              ],
              subTitle: 'Q.CSVログについて',
              url: 'csv_log',
            },
            {
              thumbnail: [
                {
                  heading: '・ご利用可能期間',
                  caption: `無料体験は${TRIAL_PERIOD_MONTH}ヶ月間無料でご利用いただけるプランです。\n例）${STR_SAMPLE_TRIAL_PERIOD_START}にご登録いただいた場合、${STR_SAMPLE_TRIAL_PERIOD_END}まで無料体験期間とさせていただきます。`,
                },
                {
                  heading: '・有料プランとの違い',
                  caption:
                    '有料プランと同様の機能をご利用いただけますが、無料体験では最大で200名までのユーザーが追加可能となっております。',
                },
                {
                  heading: '・無料体験中止の手続き方法',
                  caption: `クライアントツールをインストールいただいた端末から削除する事でご利用を中止していただけます。クライアントツールの削除については別ページ「クライアントツールの削除方法」をご覧ください。\n※有料プランへのお申込みをされずに${TRIAL_PERIOD_MONTH}ヶ月が経過した際は、自動的にご利用を停止させていただきますのでご了承ください。`,
                  links: [
                    {
                      link: 'delete_client_win',
                      linkCaption: 'クライアントツールの削除方法（Windows版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_mac',
                      linkCaption: 'クライアントツールの削除方法（Mac版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_android',
                      linkCaption: 'クライアントツールの削除方法（Android版）',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: 'Q.無料体験期間について',
              url: 'free_experience',
            },
            {
              thumbnail: [
                {
                  heading: '・有料プラン',
                  caption:
                    '月額料金は対象月の登録パソコン台数×110円（税込）となります。\n1台のパソコンを2つ以上のPCユーザーで切り替えて使用する場合、ユーザー管理画面の[デバイス]に同一PCが複数表示されますが、料金は1台分となります。\nなお、一度ユーザーのPCにクライアントツールをインストールされると、削除された場合も登録されていた月は課金の対象となりますのでご了承ください。',
                },
                {
                  heading: '・データ保管期間延長オプション',
                  caption:
                    '標準で2年間のログデータが閲覧可能となっていますが、データ保管期間延長オプションに加入いただくことでログの閲覧可能な期間を延長することができます。\n' +
                    'オプションの月額料金は対象のパソコン台数×延長年数×110円（税込）となります。',
                  links: [
                    {
                      link: 'storage_period',
                      linkCaption: 'Q.ログの保管期間について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  heading: '・ユーザーの課金対象からの解除',
                  caption:
                    '管理（課金）対象から特定のユーザーを外す場合、クライアントツールの削除が必要です。\nクライアントツールの削除については別ページ「クライアントツールの削除方法」をご覧ください。',
                  links: [
                    {
                      link: 'delete_client_win',
                      linkCaption: 'クライアントツールの削除方法（Windows版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_mac',
                      linkCaption: 'クライアントツールの削除方法（Mac版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_android',
                      linkCaption: 'クライアントツールの削除方法（Android版）',
                      isHelp: true,
                    },
                  ],
                },
                {
                  heading: '・請求について',
                  caption:
                    '有料プランをご利用いただいた月の末日に金額を算出します。\n' +
                    '- 銀行振り込みの場合、ご請求金額と振込口座を翌月1日にHTMLメールでお送りいたしますので、月末までにお振込みください。※手数料はお客様負担となります。\n' +
                    '- クレジットカード払いの場合、ご請求金額を翌月1日に請求いたします。',
                  links: [
                    {
                      link: 'invoice',
                      linkCaption: '適格請求書（インボイス）について',
                      isHelp: true,
                    },
                  ],
                },
                {
                  heading: '・お申込み方法',
                  caption:
                    'ライセンス・お支払い情報画面から有料プランの [申込み] ボタンを押し、 [銀行振り込み] もしくは [クレジットカード払い] を選択してください。\n [銀行振り込み] をご利用の場合は、翌月1日に送付させていただくご請求メールにてお振込先を記載いたします。',
                  src: '/images/help/q06_02.png',
                  srcSP: '/images/help/q06_02_sp.png',
                },
              ],
              subTitle: 'Q.ライセンス・料金について',
              url: 'license',
            },
            {
              thumbnail: [
                {
                  heading: '・毎月の適格請求書の取得について',
                  caption:
                    '有料プランご利用の翌月1日にお送りするクレジット決済メール、銀行振込のご請求メールをインボイスとしてご使用いただけます。',
                },
                {
                  heading: '・過去の請求書取得について',
                  caption:
                    'ライセンス・お支払い情報画面の [適格請求書] にて、2023年10月以降のご利用分の適格請求書を参照いただけます。\n最新の請求書は毎月1日（前月のご利用料金確定後）から表示可能になります。',
                  src: '/images/help/q12_01.png',
                  srcSP: '/images/help/q12_01_sp.png',
                },
                {
                  caption:
                    '表示された適格請求書はブラウザの機能でプリントアウトまたはファイル保存してください。',
                  src: '/images/help/q12_02.png',
                },
              ],
              subTitle: 'Q.適格請求書（インボイス）について',
              url: 'invoice',
            },
            {
              thumbnail: [
                {
                  caption:
                    '一部のPCのみご利用を解除する場合は、該当PCからクライアントツールのアンインストールをお願いいたします。\n' +
                    '有料プランの解約手順は以下の通りです。',
                },
                {
                  caption:
                    '１．トップバーから ライセンス・お支払い情報画面を表示します。',
                  src: '/images/help/q05_00.png',
                  srcSP: '/images/help/q05_00_sp.png',
                },
                {
                  caption: '２．画面右上の [解約] を押します。',
                  src: '/images/help/q05_01.png',
                  srcSP: '/images/help/q05_01_sp.png',
                },
                {
                  caption:
                    '３． ライセンス解約 という画面が表示されますので、\n注意事項をご一読いただいた後 [ライセンスを解約する] を押してください。',
                  src: '/images/help/q05_02.png',
                  srcSP: '/images/help/q05_02_sp.png',
                },
                {
                  caption:
                    '４． [ライセンスを解約する] を押した後、確認ダイアログが表示されますので、 [解約する] を押します。',
                  src: '/images/help/q05_03.png',
                  srcSP: '/images/help/q05_03_sp.png',
                },
                {
                  caption:
                    '５．クライアントツールの削除をしていただくことで退会が完了となります。\n※削除方法については、別ページ「クライアントツールの削除方法」をご覧ください。',
                  links: [
                    {
                      link: 'delete_client_win',
                      linkCaption: 'クライアントツールの削除方法（Windows版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_mac',
                      linkCaption: 'クライアントツールの削除方法（Mac版）',
                      isHelp: true,
                    },
                    {
                      link: 'delete_client_android',
                      linkCaption: 'クライアントツールの削除方法（Android版）',
                      isHelp: true,
                    },
                  ],
                },
              ],
              subTitle: 'Q.ライセンスの解約手順',
              url: 'cancellation',
            },
            {
              thumbnail: [
                {
                  caption:
                    '１．Windowsの設定【プログラムの追加と削除】を開き、「RemoLabo」と検索しアンインストールを選択します。',
                },
                {
                  caption:
                    '２．アンインストール選択時に表示されるダイアログにて、クライアントツール画面のアンインストールパスワードを入力します。\n※アンインストール後にPCの再起動をお願いいたします。',
                  src: '/images/help/q07_01.png',
                  srcSP: '/images/help/q07_01_sp.png',
                },
              ],
              subTitle: 'Q.クライアントツールの削除方法（Windows版）',
              url: 'delete_client_win',
            },
            {
              thumbnail: [
                {
                  heading: '【Mojave_10.14】',
                  caption:
                    '１．Finderを開き、 [移動] メニューから [フォルダへ移動] を選択します。',
                  src: '/images/help/mac02/01.png',
                },
                {
                  caption:
                    '２．「/ライブラリ」を入力して検索します。\n※先頭のスラッシュを忘れずに入力',
                  src: '/images/help/mac02/02.png',
                },
                {
                  caption:
                    '３．ライブラリフォルダが表示されるので、右上の検索フォームに"RemoLaboUninstaller"と入力します。',
                  src: '/images/help/mac02/03.png',
                },
                {
                  caption:
                    '４． [検索：] で [このMac] と ["ライブラリ"] が選択できるので、 ["ライブラリ"] を選択します。\nしばらく待つと、RemoLaboUninstallerのアプリが表示されます。',
                  src: '/images/help/mac02/04.png',
                },
                {
                  caption:
                    '５．RemoLaboUninstallerアプリのアイコンをダブルクリックすると、アンインストーラが起動します。\nクライアントツール画面のアンインストールパスワードを入力して[アンインストール]ボタンを押し、案内に沿ってアンインストールを進めてください。\n以上で【Mojave_10.14】版のアンインストールが完了です。',
                  src: '/images/help/mac02/05.png',
                },
                {
                  heading: '【Catalina_10.15】',
                  caption: '１．右上の虫眼鏡アイコンをクリックします。',
                },
                {
                  caption: '２．Spotlight検索の入力フォームが表示されます。',
                  src: '/images/help/mac02/06.png',
                },
                {
                  caption:
                    '３．"RemoLaboUninstaller" で検索すると、以下が表示されます。赤枠の行をダブルクリックすると、アンインストーラが起動します。',
                  src: '/images/help/mac02/07.png',
                },
                {
                  caption:
                    'クライアントツール画面のアンインストールパスワードを入力して[アンインストール]ボタンを押し、案内に沿ってアンインストールを進めてください。\n以上で【Catalina_10.15】版のアンインストールが完了です。',
                  src: '/images/help/mac02/08.png',
                },
                {
                  heading: '【上記手順でアンインストールできない場合】',
                  olCaption: [
                    {
                      captionList: [
                        {
                          caption:
                            'Finderを開き、 [移動] メニューから [フォルダへ移動] を選択します。\n\n',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            '「/Library/Application Support/RemoLabo」を入力して検索します。\n※先頭のスラッシュを忘れずに入力\n\n',
                        },
                      ],
                    },
                    {
                      captionList: [
                        {
                          caption:
                            'RemoLaboUninstallerアプリのアイコンをダブルクリックすると、アンインストーラが起動します。\nクライアントツール画面のアンインストールパスワードを入力して[アンインストール]ボタンを押し、案内に沿ってアンインストールを進めてください。\n\n以上でアンインストールが完了します。',
                        },
                      ],
                    },
                  ],
                },
              ],
              subTitle: 'Q.クライアントツールの削除方法（Mac版）',
              url: 'delete_client_mac',
            },
            {
              thumbnail: [
                {
                  caption:
                    'アプリドロワーにあるremolabo_clientのアプリアイコンを長押しし、' +
                    '\nアンインストールをタップします。',
                  src: '/images/help/android/01.png',
                },
                {
                  caption:
                    'または、' +
                    '\n設定アプリ → アプリ → remolabo_client →　削除(アンインストール)' +
                    '\nの手順でも可能です。',
                },
              ],
              subTitle: 'Q.クライアントツールの削除方法（Android版）',
              url: 'delete_client_android',
            },
          ],
        },
      ] as IQAData[],
      setTitleData: '',
      setModalData: {} as IQAItem,
      answerOpen: false,
    };
  },
  props: {
    article: String,
  },
  watch: {
    // 戻るボタン押下時
    answerOpen(isOpen: boolean) {
      if (!isOpen) {
        this.$emit('helplink', ''); // URLを"/help"に戻す
      }
    },
    // ヘルプの一覧から項目選択時
    article(value: string) {
      this.selectHelp(value || '');
    },
  },

  async mounted() {
    this.selectHelp(this.$route.params.article);
  },
  methods: {
    selectHelp(urlValue: string) {
      if (urlValue) {
        const item = this.qafList2[0].items.find(v => v.url === urlValue);
        if (item) {
          this.openModal(this.qafList2[0].title, item);
        } else {
          const item2 = this.qafList[0].items.find(v => v.url === urlValue);
          if (item2) {
            this.openModal(this.qafList[0].title, item2);
          }
        }
      } else {
        this.answerOpen = false;
      }
    },
    openModal(title: string, data: IQAItem) {
      window.scrollTo(0, 0);
      this.setTitleData = title;
      this.setModalData = data;
      this.answerOpen = true;
    },
  },
});
